import reviewsActionTypes from '../actionTypes/reviewsActionTypes';
import { getReviewsApi, getUserReviewsApi, getProductReviewsApi } from '../../api/apiUrls/reviews';

const getReviewsStart = () => ({
  type: reviewsActionTypes.GET_REVIEWS_START,
});
const getReviewsSuccess = (payload) => ({
  type: reviewsActionTypes.GET_REVIEWS_SUCCESS,
  payload,
});
const getReviewsFail = () => ({
  type: reviewsActionTypes.GET_REVIEWS_FAILURE,
});

const getReviews = (token, params) => (dispatch) => {
  dispatch(getReviewsStart());

  return getReviewsApi(token, params)
    .then((response) => {
      if (response.data.success) {
        dispatch(getReviewsSuccess(response.data));
      }
    })
    .catch(() => {
      dispatch(getReviewsFail());
    });
};

const getUserReviewsStart = () => ({
  type: reviewsActionTypes.GET_USER_REVIEWS_START,
});
const getUserReviewsSuccess = (payload) => ({
  type: reviewsActionTypes.GET_USER_REVIEWS_SUCCESS,
  payload,
});
const getUserReviewsFail = () => ({
  type: reviewsActionTypes.GET_USER_REVIEWS_FAILURE,
});

const getUserReviews = (userId, params = { page: 1 }) => (dispatch) => {
  dispatch(getUserReviewsStart());

  return getUserReviewsApi(userId, params)
    .then((response) => {
      if (response.data.success) {
        dispatch(getUserReviewsSuccess(response.data));
      }
    })
    .catch(() => {
      dispatch(getUserReviewsFail());
    });
};

const getProductReviewsStart = () => ({
  type: reviewsActionTypes.GET_PRODUCT_REVIEWS_START,
});
const getProductReviewsSuccess = (payload) => ({
  type: reviewsActionTypes.GET_PRODUCT_REVIEWS_SUCCESS,
  payload,
});
const getProductReviewsFail = () => ({
  type: reviewsActionTypes.GET_PRODUCT_REVIEWS_FAILURE,
});

const getProductReviews = (link, params = { page: 1 }) => (dispatch) => {
  dispatch(getProductReviewsStart());

  return getProductReviewsApi(link, params)
    .then((response) => {
      if (response.data.success) {
        dispatch(getProductReviewsSuccess(response.data));
      }
    })
    .catch(() => {
      dispatch(getProductReviewsFail());
    });
};

const reviewsActions = {
  getReviews,
  getUserReviews,
  getProductReviews,
};

export default reviewsActions;
